import type { LeadEventType, LeadType } from '@econtractor/types';

/** Заявка зайшла з сайту (form-capture) або inbound API — не створена менеджером у CRM. */
export const isExternalLeadIntake = (lead: LeadType | null | undefined): boolean => {
    if (!lead) return false;
    if (lead.isExternalIntake) return true;
    if (Number(lead.leadSourceId) > 0) return true;
    return String(lead.leadSourceMessage || '').trim().length > 0;
};

export const getLeadCreationEventId = (events: LeadEventType[] | null | undefined): number | null => {
    if (!events?.length) return null;
    return events.reduce((oldest, event) => (event.eventCreated < oldest.eventCreated ? event : oldest)).ID;
};

export const shouldHideLeadCreationAuthor = (
    lead: LeadType | null | undefined,
    event: LeadEventType,
    creationEventId: number | null,
): boolean => {
    if (!creationEventId || event.ID !== creationEventId) return false;
    return isExternalLeadIntake(lead);
};
